// What @3dp/ui's font control and font sheet need of the core (unify-ui ship 4a). @3dp/ui imports nothing of @3dp/core
// (ruling R87, packages/ui/test/shell.test.js): each text tool imports this one object and hands it to
// createFontControl({ core }). Pure — constants and plain functions, no wasm, no DOM — a page-side subpath.
import { MOODS, CJK_TAGS } from './curated.js';
import { classify, fontRank } from '../scripts.js';
import { fontKey, defaultWeight, curatedEntry } from './catalog.js';
import { asListed } from './choose.js';

export const PICKER_CORE = Object.freeze({ MOODS, CJK_TAGS, classify, fontRank, fontKey, defaultWeight, curatedEntry, asListed });
